import { render, staticRenderFns } from "./SetApprovers_Form.vue?vue&type=template&id=516c5ea0&scoped=true"
import script from "./SetApprovers_Form.vue?vue&type=script&lang=js"
export * from "./SetApprovers_Form.vue?vue&type=script&lang=js"
import style0 from "./SetApprovers_Form.vue?vue&type=style&index=0&id=516c5ea0&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516c5ea0",
  null
  
)

export default component.exports